import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"

export const unlockProjectFromLegacy = api(async function unlockProjectFromLegacy({ projectId }) {
    return mutate(
        gql`
            mutation UnlockProjectFromLegacy($projectId: String!) {
                unlockProjectFromLegacy(projectId: $projectId) {
                    success
                    error
                    restoredDraftCount
                }
            }
        `,
        { projectId },
        { returns: "unlockProjectFromLegacy" }
    )
})
